import { DialogTemplate } from 'inpock-ui-react';

const DialogModuleName = 'order.tsx';

const Template = {
  cancel: {
    exception: (message?: string) => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="cancel-exception"
          title="주문을 취소할 수 없어요 💦"
          message={
            <>
              {message && (
                <>
                  {message}
                  <br />
                </>
              )}
              취소를 원하실 경우 문의하기를 이용해주세요.
            </>
          }
        />
      );
    },
    cash: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="cancel-cash"
          title="상품 문의를 통해 취소해주세요 💁‍♀️"
          message={
            <>
              가상계좌 주문의 경우
              <br />
              상품 문의를 통해서만 취소 할 수 있어요
            </>
          }
        />
      );
    },
    impossible: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="cancel-impossible"
          title="상품 문의를 통해 취소해주세요 💁‍♀️"
          message={
            <>
              일부 상품이 취소할 수 없는 상태에요
              <br /> 취소를 원하시면 상품 문의를 남겨주세요
            </>
          }
        />
      );
    },
    unpaid: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="cancel-unpaid"
          title="주문을 취소할 수 없어요 💦"
          message={
            <>
              가상계좌 주문은 1시간 내에 입금하지 않으면
              <br />
              자동으로 취소돼요
            </>
          }
        />
      );
    },
    onlyPaid: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="cancel-only-paid"
          title="주문을 취소할 수 없어요 💦"
          message={
            <>
              결제완료 상태에서만 취소할 수 있어요
              <br />
              취소를 원하실 경우 상품 문의를 남겨주세요
            </>
          }
        />
      );
    },
  },
  refund: {
    notEnough: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="refund-not-enough"
          title="주문을 취소할 수 없습니다 🚫"
          message={
            <>
              결제금액보다 추가 배송비가 커서
              <br />
              다른 상품을 함께 취소해 주셔야 해요
            </>
          }
        />
      );
    },
    alreadyCanceled: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="refund-already-canceled"
          title="주문을 취소할 수 없습니다 🚫"
          message={<>이미 주문이 취소된 상품입니다</>}
        />
      );
    },
    additionalProduct: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="refund-additional-product"
          title="추가상품도 함께 취소해주세요 ✅"
          message={
            <>
              추가 상품만 구매하는 것은 불가능하므로
              <br />
              본품 취소시 추가 상품도 함께 취소해주세요
            </>
          }
        />
      );
    },
    impossible: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="refund-impossible"
          title="주문을 취소할 수 없어요 💦"
          message={
            <>해당 상품은 취소가 불가능한 상품입니다 자세한 내용은 판매자에게 문의해주세요</>
          }
        />
      );
    },
    error: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="refund-error"
          title="환불 예정 금액 계산 실패 🚫"
          message={
            <>
              예기치 못한 문제가 발생했어요
              <br />
              인포크링크 팀에 문의해주세요
            </>
          }
        />
      );
    },
  },
  editDelivery: {
    error: (message?: string) => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="edit-delivery"
          title="배송지 변경 실패 🚫"
          message={<>{message ? message : '예기치 못한 문제가 발생했어요'}</>}
        />
      );
    },
  },
  back: () => {
    return (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="declined-confirm"
        title="뒤로가기 방지 🛡"
        message={
          <>
            정말 페이지를 이동하실 건가요?
            <br />
            변경사항이 저장되지 않을 수 있어요
          </>
        }
      />
    );
  },
  share: () => {
    return (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="share"
        title="상품 링크 복사 완료 🛍"
        message={
          <>
            원하는 곳에 링크를 붙여넣어 <br />
            상품을 공유해보세요
          </>
        }
      />
    );
  },
  campaign: {
    signin: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="campaign-signin"
          title="로그인 정보가 만료됐어요 😭"
          message={
            <>
              계속해서 구매하시려면 아래 버튼을 통해 <br /> 다시 로그인 해주세요
            </>
          }
        />
      );
    },

    cs: () => (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="campaign-cs"
        title="상품 문의하기"
        message={
          <>
            아래 연락처로 연락해주세요
            <br /> 01077568431
          </>
        }
      />
    ),

    invalid: () => (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="campaign-invalid"
        title="상품 주문 실패 🚫"
        message={
          <>
            예기치 못한 문제가 발생했어요
            <br />
            인포크링크 팀에 문의해주세요
          </>
        }
      />
    ),
    remote_area: (type: string) => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="campaign-remote-area"
          title={`${type} 구매 불가 상품 😢`}
          message={
            <>
              해당 상품 경우 <br />
              {type}은 구매할 수 없어요
            </>
          }
        />
      );
    },
    not_enough_stock: () => (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="campaign-not-enough-stock"
        title={'상품 재고 부족 😢'}
        message={
          <>
            재고가 부족하여 <br /> 결제를 진행할 수 없어요
          </>
        }
      />
    ),
  },
  shippingType: {
    new: (shippingType: 'remote' | 'jeju') => {
      const shppingTypeLabel = shippingType === 'remote' ? '도서산간' : '제주';
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="shipping-type-new"
          title={`${shppingTypeLabel} 배송비가 부과됩니다`}
          message={<>주소에 따른 {shppingTypeLabel} 배송비가 부과되었습니다.</>}
        />
      );
    },
    change: () => {
      return (
        <DialogTemplate
          moduleName={DialogModuleName}
          classSuffix="shipping-type-change"
          title="배송비 금액이 변경되었습니다"
          message={
            <>
              주소에 따른 지역별 추가 배송비가
              <br />
              변경되었습니다.
            </>
          }
        />
      );
    },
  },
};

export default Template;
